export default __webpack_public_path__ + "static/media/2021.26426cbf.mp3";